import React, { useState, useEffect } from "react";

export default function HomeSeoText(props) {
    const [textHTML, setTextHTML] = useState(null);
    const baseUrl = casino.utils.getBaseUrl();

    useEffect(() => {
        let category = props.tabCategoryId;

        let currentUrl = window.location.href;

        let pageInfo = getPageInfo(currentUrl, category ? category : null);

        if (pageInfo) {
            casino.repos.casinoDocumentsRepo.get(pageInfo.url).then((dataHTML) => {
                setTextHTML(dataHTML);
            });
        } else {
            setTextHTML(null);
        }
    }, [props.tabCategoryId, props.route.location]);

    function getPageInfo(pageUrl, categoryId) {
        if (pageUrl == baseUrl && categoryId == -1)
            return { url: 'seo/casino/casinohomepage.html' };
        else if (pageUrl.includes('winners'))
            return { url: 'seo/casino/dobitnici.html' };
        else if (pageUrl.includes('all-promotions'))
            return null;
        else if (pageUrl.includes('promotions'))
            return { url: 'seo/casino/promocije.html' };
        else if (pageUrl.includes('provideri'))
            return { url: 'seo/casino/provideri.html' };
        else if (pageUrl.includes('teme'))
            return { url: 'seo/casino/teme.html' };
        else if (pageUrl.includes('casino-utrke'))
            return { url: 'seo/casino/casinoutrke.html' };
        else if (pageUrl.includes('casino-izazovi'))
            return { url: 'seo/casino/casinoizazovi.html' };
        else if (pageUrl.includes('kontakt'))
            return { url: 'seo/casino/Kontakt.html' };
        else if (pageUrl.includes('faq'))
            return { url: 'seo/casino/Faq.html' };
        else if (pageUrl.includes('popis-igara'))
            return { url: 'seo/casino/PopisIgara.html' };
        //else if (pageUrl.includes('certifikati'))
        //   return { url: 'seo/casino/Certifikati.html' };
        else if (pageUrl.includes('odgovorno-igranje'))
            return { url: 'seo/casino/OdgovornoIgranje.html' };
        //else if (pageUrl.includes('plus18'))
        //    return { url: 'seo/casino/Plus18.html' };
        else if (pageUrl.includes('politika-kolacica'))
            return { url: 'seo/casino/PolitikaKolacica.html' };
        else if (pageUrl.includes('obavijest-o-obradi-osobnih-podataka'))
            return { url: 'seo/casino/ObavijestOObradiOsobnihPodataka.html' };
        else if (categoryId == 6)
            return { url: 'seo/casino/slotovi.html' };
        else if (categoryId == 7)
            return { url: 'seo/casino/igrezastolom.html' };
        else if (categoryId == 10)
            return { url: 'seo/casino/jackpot.html' };
        else
            return null;
    }

    return (
        <>
            {textHTML != null && textHTML != '' && <div className="dep-footer-content">
                <div className="dep-text">
                    <div className="content" dangerouslySetInnerHTML={{ __html: textHTML }}></div>
                </div>
            </div>}
        </>
    )
}